import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import { AI_AGENT_ACCESS_INFO_TEXT, AI_AGENT_ACCESS_TOGGLE_TEXT } from '../account-admin.text';
import { AIAgentAccessFormVM } from './ai-agent-access-form.viewmodel';

interface IAIAgentAccessFormPresentationProps {
    vm: AIAgentAccessFormVM;
}

const AIAgentAccessFormPresentation = observer(
    (props: IAIAgentAccessFormPresentationProps) => {
        const { vm } = props;

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <div className='oe-form'>
                        <div className='oe-form__body'>
                            <div className='m-top-10px m-bottom-0px flex center'>
                                <OEToggle
                                    isSelected={vm.settingsEntity.enabled}
                                    onClick={vm.settingsEntity.toggleEnabled}
                                    dataTestId='ai-agent-access'
                                />
                                <Text
                                    {...AI_AGENT_ACCESS_TOGGLE_TEXT}
                                    values={{
                                        suffix: vm.settingsEntity.suffix
                                    }}
                                    className='line-height-25px'
                                />
                            </div>
                            <div className='account-admin-modal-info'>
                                <FormattedMessage {...AI_AGENT_ACCESS_INFO_TEXT} />
                            </div>
                        </div>
                    </div>
                }
                footer={
                    <AccountAdminSettingFormFooter
                        handleClose={vm.handleClose}
                        handleSubmit={vm.handleSubmit}
                        isDisabled={vm.saving}
                    />
                }
            />
        );
    }
);

export { AIAgentAccessFormPresentation };
